module.exports = __webpack_public_path__ + "static/media/Logo-Finika.c8dd64fc.png";